




import { defineComponent } from '@vue/composition-api';
import imgFailedImg from '@tt4b/ttam-assets/src/images/img-failed.png';

export default defineComponent({
  name: 'BackupImg',
  props: {
    src: {
      type: [String],
      required: true,
    },
    backup: {
      type: [String, Object],
      default: imgFailedImg,
    },
  },
  data() {
    return {
      value: this.src,
    };
  },
  watch: {
    src(val) {
      this.value = val;
    },
  },
  methods: {
    handleError() {
      this.value = imgFailedImg;
    },
  },
});
